import {useState} from 'react';
import Input from "./inputs/Input";
import { useForm } from 'react-hook-form';
import Button from './Button';

const ContactForm = (props) => {
    const formValues = {
        firstName:"",
        lastName:"",
        email:"",
        phone:"",
        jobTitle:"",
        companySize:"",
        problem:""
    };

    const [isLoading,setIsLoading]  = useState(false)
    const {register,handleSubmit,reset,formState:{errors}} = useForm({
        defaultValues:formValues
    })

    const submitHandler = (data) => {
        console.log(data)
        reset(formValues);
    }

    return (
        <div className={props.className}>
            <div className="form-group">
                <Input 
                    label={'Full Name'}                        
                    id={'fullName'}   
                    name={'fullName'}  
                    placeholder='Full Name'   
                    disabled={isLoading}
                    register={register}
                    errors={errors}
                    required                                           
                />
            </div>
            <div className="form-group">
                <Input 
                    label={'Email'}                        
                    id={'email'}   
                    name={'email'}  
                    placeholder='Email'   
                    disabled={isLoading}
                    register={register}
                    errors={errors}
                    required                                           
                />
            </div>
            <div className="form-group">
                <Input 
                    label={'Phone'}                        
                    id={'phone'}   
                    name={'phone'}  
                    placeholder='Phone'   
                    disabled={isLoading}
                    register={register}
                    errors={errors}
                    required                                           
                />
            </div>
            <div className="form-group">                
                <Input 
                    type='textarea'
                    label={'Additional Information'}                        
                    id={'phone'}   
                    name={'phone'}  
                    placeholder='Additional Information'   
                    disabled={isLoading}
                    register={register}
                    errors={errors}
                    required                                           
                />
            </div>
            <div className="mt-5">
                <Button 
                    icon={''}
                    title={'Send Message'}
                    onClick={handleSubmit(submitHandler)}
                />                                                    
            </div>  
        </div>
    );
};

export default ContactForm;